import { useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';

function BackIconButton() {
  const navigate = useNavigate();
  return (
    <IconButton aria-label="back" size="large" onClick={() => navigate(-1)}>
      <ArrowBackIcon />
    </IconButton>
  );
}

export default BackIconButton;
